export default __webpack_public_path__ + "static/media/bidplace.d1d3f10c.svg";